import React from "react";
import Footer from "./Footer";
import { rewardsOverviewText } from "../../settings/Constants";
import Button from "../UI/Button";
import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";
import { guestbookSites, environment } from "../../settings/websiteURLs";

const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${({ theme }) => theme.laptop`
      justify-content: space-evenly;
  `}
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${rem("455px")};
  height: ${rem("455px")};
  margin-bottom: ${rem("40px")};

  ${({ backgroundImg }) => css`
    background-image: url(${backgroundImg});
    background-size: cover;
    background-position: center;
  `}

  ${({ coloredTiles, primaryColor }) =>
    coloredTiles == "true" &&
    css`
      background-image: unset;
      background-color: #${primaryColor};
    `}

  > button {
    font-weight: 600;
    color: #343638;
    margin: 0 auto;
  }
`;

const CardText = styled.div`
  text-align: center;
  color: #ffffff;
  font-size: ${rem("32px")};
  letter-spacing: ${rem("1.12px")};
  line-height: ${rem("30px")};
  margin-bottom: ${rem("8px")};
  font-weight: 600;

  ${({ type }) =>
    type == "description" &&
    css`
      max-width: ${rem("366px")};
      font-size: ${rem("17px")};
      letter-spacing: ${rem("0px")};
      font-weight: 400;
      line-height: ${rem("27px")};
      margin-bottom: ${rem("24px")};
    `}
`;

const SignUpCard = styled.div`
  width: ${rem("455px")};
  height: ${rem("455px")};
  display: flex;
  ${({ primaryColor }) => css`
    background-color: #${primaryColor};
  `}
`;

const SignUpCardContent = styled.div`
  margin: auto;
  width: ${rem("203px")};
`;

const SignUpCardContentText = styled.div`
  ${({ type }) =>
    type == "header" &&
    css`
      font-size: ${rem("22px")};
      font-weight: 600;
      color: #ffffff;
      line-height: ${rem("34px")};
      margin-bottom: ${rem("11px")};
      width: ${rem("190px")};
    `}

  ${({ type }) =>
    type == "subtext" &&
    css`
      font-size: ${rem("14px")};
      color: #ffffff;
      font-weight: 400;
      line-height: ${rem("20px")};
      margin-bottom: ${rem("20px")};
    `}
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > a {
    > button {
      padding: ${rem("13px")};
      font-weight: 600;
      line-height: ${rem("14px")};
    }
  }
  > :first-child {
    margin-bottom: ${rem("20px")};
  }
  > :last-child {
    > button {
      &:hover {
        color: #343638;
        background-color: #ffffff;
      }
    }
  }
`;

const ImageContainer = styled.div`
  margin: auto ${rem("30px")} auto ${rem("0px")};

  > img {
    width: ${rem("159px")};
  }
`;

const Card = ({
  cardInfo,
  coloredTiles,
  primaryColor,
  setPage,
  widgetIdentifier,
}) => {
  return (
    <CardContainer
      backgroundImg={
        widgetIdentifier === "mondrianparkavenue" &&
        (cardInfo.title === "CASH FOR A CAUSE" ||
          cardInfo.title === "CASH FORWARD")
          ? cardInfo.backgroundImgMondrian
          : widgetIdentifier.includes("yotel")
          ? cardInfo.backgroundImgYotel
          : cardInfo.backgroundImg
      }
      coloredTiles={coloredTiles}
      primaryColor={primaryColor}
    >
      <CardText>{cardInfo.title}</CardText>
      <CardText type="description">{cardInfo.description}</CardText>
      <Button
        kind="rewards_overview"
        inverted
        onClick={() => setPage(cardInfo.title)}
        width="241px"
      >
        {cardInfo.buttonText}
      </Button>
    </CardContainer>
  );
};

Card.propTypes = {
  cardInfo: PropTypes.object.isRequired,
  coloredTiles: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  primaryColor: PropTypes.string.isRequired,
  setPage: PropTypes.func.isRequired,
  widgetIdentifier: PropTypes.string.isRequired,
};

const Home = ({
  includeInstay,
  coloredTiles,
  primaryColor,
  widgetIdentifier,
  setPage,
  darkMode,
}) => {
  // TODO: look into creating a variable on RA to allow custom links.
  const signupLink =
    widgetIdentifier === "legacyvacationbrigantine"
      ? "/reward_sign_up/legacyvacationresorts"
      : "/reward_sign_up/" + widgetIdentifier;

  return (
    <>
      <CardGrid>
        {includeInstay ? (
          <Card
            cardInfo={rewardsOverviewText.instayCard}
            coloredTiles={coloredTiles}
            primaryColor={primaryColor}
            setPage={setPage}
            widgetIdentifier={widgetIdentifier}
          />
        ) : null}
        {rewardsOverviewText.nonInstayCards.map((card) => (
          <Card
            key={card.title}
            cardInfo={card}
            coloredTiles={coloredTiles}
            primaryColor={primaryColor}
            setPage={setPage}
            widgetIdentifier={widgetIdentifier}
          />
        ))}
        {!includeInstay ? (
          <SignUpCard primaryColor={primaryColor}>
            <SignUpCardContent>
              <SignUpCardContentText type="header">
                {rewardsOverviewText.signupCard.header}
              </SignUpCardContentText>
              <SignUpCardContentText type="subtext">
                {rewardsOverviewText.signupCard.description}
              </SignUpCardContentText>
              <ButtonWrapper>
                <Button
                  kind="rewards_overview"
                  inverted
                  href={guestbookSites[environment].guestbook.url + signupLink}
                  targetBlank={true}
                  width="158px"
                >
                  {rewardsOverviewText.signupCard.cardSignup}
                </Button>
                <Button
                  kind="rewards_overview"
                  href={
                    guestbookSites[environment].guestbook.url +
                    "/redeem?spu=true"
                  }
                  targetBlank={true}
                  width="158px"
                >
                  {rewardsOverviewText.signupCard.login}
                </Button>
              </ButtonWrapper>
            </SignUpCardContent>
            <ImageContainer>
              <img src={rewardsOverviewText.signupCard.tileImage}></img>
            </ImageContainer>
          </SignUpCard>
        ) : null}
      </CardGrid>
      {includeInstay ? (
        <Footer widgetIdentifier={widgetIdentifier} darkMode={darkMode} />
      ) : null}
    </>
  );
};

Home.propTypes = {
  includeInstay: PropTypes.bool.isRequired,
  coloredTiles: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  primaryColor: PropTypes.string.isRequired,
  widgetIdentifier: PropTypes.string.isRequired,
  setPage: PropTypes.func.isRequired,
};

export default Home;
